
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M19.622 1.5C9.63 1.5 1.5 9.629 1.5 19.621c0 9.992 8.13 18.121 18.122 18.121 9.992 0 18.122-8.129 18.122-18.121 0-9.992-8.13-18.121-18.122-18.121m0 37.742C8.802 39.242 0 30.44 0 19.621 0 8.802 8.802 0 19.622 0s19.622 8.802 19.622 19.621c0 10.819-8.803 19.621-19.622 19.621"}}),_c('path',{attrs:{"d":"M19.653 10.163l.074.002a1.7 1.7 0 001.697-1.634c.037-.953-.712-1.731-1.705-1.77-.91 0-1.657.717-1.695 1.632a1.705 1.705 0 001.63 1.77m1.112 3.047H16.45v1.12h2.233v17.032h-2.031v1.12h6.143v-1.12h-2.031z"}})])])
          )
        }
      }
    